export default {
  public: [],
  private: []
}